import CheckoutBreadcrumbs from '@features/purchasing/components/CheckoutBreadcrumbs';
import { ICheckoutStep } from '@features/purchasing/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import CheckoutForm from './CheckoutForm';
import CheckoutFormStep from './steps/CheckoutFormStep';
import StepAdditionalInformation from './steps/StepAdditionalInformation';
import StepCustomer from './steps/StepCustomer';
import StepMethods from './steps/StepMethods';
import { ICheckoutAddress, ICheckoutCustomer, IPaymentMethod, IShippingMethod } from './types';

interface IProps {
  title: string;
  steps: ICheckoutStep[];
  note?: string;
  customer: ICheckoutCustomer;
  shippingAddresses?: ICheckoutAddress[];
  countries: { [key: string]: string };
  methods: {
    shippingMethodId?: string;
    shippingMethods: IShippingMethod[];
    paymentMethodId?: string;
    paymentMethods: IPaymentMethod[];
  };
  urls: {
    setWizard: string;
    previousStep: string;
    nextStep: string;
  };
}

const WizardSteps = 3;

export default function Index({
  title,
  steps,
  note,
  customer,
  shippingAddresses,
  countries,
  methods,
  urls: { previousStep, nextStep, setWizard },
}: IProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="max-w-3xl flex flex-col mx-auto">
        {steps && <CheckoutBreadcrumbs steps={steps} />}

        <h1 className="flex flex-col laptop:flex-row items-center laptop:items-baseline laptop:justify-center gap-x-2">
          <small className="text-primary">{title}</small>
        </h1>

        <CheckoutForm
          customer={customer}
          shippingMethodId={methods.shippingMethodId}
          paymentMethodId={methods.paymentMethodId}
          note={note}
          nextStepUrl={nextStep}
          setCheckoutWizardUrl={setWizard}>
          <CheckoutFormStep step={1} maxStep={WizardSteps} title={t('Checkout.Section.Customer')}>
            <StepCustomer
              shippingAddresses={shippingAddresses}
              countries={countries}
              {...customer}
            />
          </CheckoutFormStep>

          <CheckoutFormStep step={2} maxStep={WizardSteps} title={t('Checkout.Section.Methods')}>
            <StepMethods {...methods} />
          </CheckoutFormStep>

          <CheckoutFormStep
            step={3}
            maxStep={WizardSteps}
            title={t('Checkout.Section.AdditionalInformation')}>
            <StepAdditionalInformation onBack={() => (location.href = previousStep)} />
          </CheckoutFormStep>
        </CheckoutForm>
      </div>
    </>
  );
}
